import script from "./OcrDownloadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OcrDownloadModal.vue?vue&type=script&setup=true&lang=ts"

import "./OcrDownloadModal.vue?vue&type=style&index=0&id=659eeaca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-659eeaca"]])

export default __exports__